import { render, staticRenderFns } from "./DeletedEndpoints.vue?vue&type=template&id=b48f6fa2"
import script from "./DeletedEndpoints.vue?vue&type=script&lang=js"
export * from "./DeletedEndpoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48f6fa2')) {
      api.createRecord('b48f6fa2', component.options)
    } else {
      api.reload('b48f6fa2', component.options)
    }
    module.hot.accept("./DeletedEndpoints.vue?vue&type=template&id=b48f6fa2", function () {
      api.rerender('b48f6fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/DeletedEndpoints.vue"
export default component.exports